import { getQaSelector } from '../../../../utils/common'
import {
  MATCH_SCORE_RING_SIZE,
  QA_NAME_MATCH_SCORE_RING,
} from '../RentalPortalMatch.constants'

import { MATCH_SCORE_RING_STROKE } from './RentalPortalMatchScoreRing.constants'
import {
  getMatchScoreRingArc,
  getMatchScoreRingGeometry,
} from './RentalPortalMatchScoreRing.utils'

import * as styles from './RentalPortalMatchScoreRing.module.css'

function RentalPortalMatchScoreRing({
  className = styles.RentalPortalMatchScoreRing,
  score,
  size = MATCH_SCORE_RING_SIZE.table,
}) {
  const { center, circumference, radius } = getMatchScoreRingGeometry(size)

  return (
    <svg
      {...getQaSelector({ value: QA_NAME_MATCH_SCORE_RING })}
      className={className}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
    >
      <circle
        className={styles.track}
        cx={center}
        cy={center}
        r={radius}
        strokeWidth={MATCH_SCORE_RING_STROKE}
      />
      <circle
        className={styles.value}
        cx={center}
        cy={center}
        r={radius}
        strokeDasharray={getMatchScoreRingArc({ circumference, ratio: score })}
        strokeWidth={MATCH_SCORE_RING_STROKE}
      />
    </svg>
  )
}

export default RentalPortalMatchScoreRing
